export default __webpack_public_path__ + "static/media/group-people-gray.f85f1550.svg";